import { horizontalEllipsis } from '@ipfabric/frontend-shared-assets/utils/characters';
import { mergeRefs } from '@ipfabric/frontend-shared-assets/utils/react/mergeRefs';
import classNames from 'classnames';
import { type FC, useRef } from 'react';
import {
  getAccessibleTabIndex,
  getAriaButtonRoleAttribute,
  handleAccessibleButtonKeyDown,
} from '../Button/ariaHelpers';
import { Icon } from '../Icon/Icon';
import { TextInput } from '../TextInput/TextInput';
import { getFileUploadClassNames } from './FileUpload.styles';
import type { FileUploadProps } from './FileUpload.types';

export const FileUpload: FC<FileUploadProps> = ({
  size = 'default',
  disabled,
  externalRef,
  placeholder,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const fileUploadClassNames = getFileUploadClassNames({
    disabled,
    className: props.className,
  });

  return (
    <div
      className={fileUploadClassNames.container}
      onClick={() => {
        !disabled && inputRef.current?.click();
      }}
      {...getAriaButtonRoleAttribute()}
      tabIndex={getAccessibleTabIndex(disabled)}
      onKeyDown={(e) => {
        handleAccessibleButtonKeyDown(e, disabled);
      }}
    >
      <input
        name={props.name}
        ref={mergeRefs(inputRef, externalRef)}
        type='file'
        className='hidden'
        onChange={(e) => {
          const newFile = e.target.files?.[0];
          if (newFile) {
            props.onFileSelected?.(newFile, e);
          }
        }}
        id={props.inputId}
      />
      <TextInput
        readOnly
        size={size}
        disabled={disabled}
        type='text'
        placeholder={placeholder ?? `Choose${horizontalEllipsis}`}
        className={classNames(
          props.inputProps?.className,
          'cursor-pointer',
          '[&_input]:cursor-pointer',
        )}
        hasError={props.hasError}
        value={props.value?.name ?? ''}
        loading={props.loading}
        startAdornment={<Icon glyph='fa-file-import' iconStyle='regular' />}
        endAdornment={
          props.loading ? undefined : (
            <span className={fileUploadClassNames.adornmentLabel}>
              Choose file
            </span>
          )
        }
      />
    </div>
  );
};
